import React from 'react';
import Skeleton from 'react-loading-skeleton';

const LoadingFile = () => (
  <>
    <header className="file-header">
      <div className="file-header-info">
        <div>
          <h5><Skeleton width={200} /></h5>
        </div>
        <div>
          <Skeleton width={100} />
        </div>
      </div>
      <ul className="file-navigation">
        <Skeleton width={400} />

        <li className="navigation-close">
          <Skeleton width={30} />
        </li>
        {/* </Button> */}
      </ul>
    </header>
    <div className="file-body">
      <div className="file-content">
        <div className="file-inner file-inner-loader">
          <div className="file-tools-ribbon-wrapper">
            <Skeleton width={750} height={48} borderRadius={24} />
          </div>
          <div className="file-wrapper file-wrapper-loader">
            <div className="file-image-wrapper">
              <Skeleton width={600} height={320} />
            </div>
          </div>
        </div>
      </div>
      <aside className="file-sidebar">
        <div className="file-sidebar-inner">
          <div className="file-sidebar-nav">
            <Skeleton width={78} />
            <Skeleton width={65} />
            <Skeleton width={85} />
            <Skeleton width={88} />
            <Skeleton width={102} />
          </div>
          <div className="file-sidebar-content">
            <div className="collapse show">
              <div className="file-sidebar-content-scrollable">
                <div className="file-general-info file-details-item">
                  <div className="file-detail-body">
                    <h5 className="file-name">
                      <Skeleton width={230} />
                    </h5>
                    <div className="file-details-wrapper">
                      <div className="file-details">
                        <div>
                          <span><Skeleton width={150} /></span>
                        </div>
                      </div>
                    </div>
                    <div className="file-details-wrapper">
                      <span><Skeleton width={150} /></span>
                      <span><Skeleton width={250} /></span>
                      <span><Skeleton width={170} count={2} /></span>
                    </div>
                    <div className="file-details-wrapper">
                      <div className="file-details">
                        <div>
                          <span><Skeleton width={220} count={2} /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  </>
);

export default LoadingFile;
